import { render, staticRenderFns } from "./Publisher.vue?vue&type=template&id=78ea0612&lang=pug"
import script from "./Publisher.vue?vue&type=script&lang=ts"
export * from "./Publisher.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports